import React from "react";
import { ICardProps } from "./types";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { useReceiptCardInfo } from "./handlers/useReceiptCardInfo";
import TripOriginRoundedIcon from "@mui/icons-material/TripOriginRounded";
import { useTranslation } from "react-i18next";

const LeftCard: React.FC<ICardProps> = ({ data }) => {
  const { t } = useTranslation("paymentPage");
  const {
    status,
    mainTitle,
    pickupDisplayName,
    pickupAddress,
    dropoffDisplayName,
    dropoffAddress,
    pickupTime,
    updatedAtPOI,
  } = useReceiptCardInfo(data);
  const updatedAt = status === "COMPLETED" ? updatedAtPOI : "";
  return (
    <div
      className="
      bg-white flex flex-col p-[16px] w-full
      border-0 border-b-2 border-b-gray-400 rounded-b-lg
      mx-0
      md:border md:border-gray-400 md:rounded-lg 
  
      
      md:mt-5 md:w-auto md:rounded-lg md:border-b-gray-400
    "
    >
      <div className="text-base font-semibold text-mineshaft-900 mb-1">
        {t("yourReservationDetails")}
      </div>
      <div className="text-3xl font-bold leading-none mb-4 break-words">
        {mainTitle}
      </div>
      <hr className="mb-4" />
      <div className="flex flex-col gap-0">
        {/* Pickup row */}
        <div className="flex flex-row items-start">
          <div className="flex flex-col items-center min-w-[28px]">
            <span className="w-7 h-7 flex items-center justify-center">
              <TripOriginRoundedIcon sx={{ color: "#1479c7", fontSize: 20 }} />
            </span>
            {/* Dashed line below pickup icon */}
            <div className="border-l-2 border-dashed border-gray-400 h-10 mt-0.5 mb-0.5" />
          </div>
          <div className="flex flex-col justify-center pl-2 min-h-[28px]">
            <span className="text-sm font-normal leading-tight text-mineshaft-700">
              {pickupTime}
            </span>
            <span className="text-base font-semibold leading-tight text-mineshaft-900">
              {pickupDisplayName}
            </span>
            <div className="text-sm font-normal leading-tight text-mineshaft-700">
              {pickupAddress}
            </div>
          </div>
        </div>
        {/* Dropoff row */}
        <div className="flex flex-row items-start mt-1">
          <div className="flex flex-col items-center min-w-[28px]">
            <span className="w-7 h-7 flex items-center justify-center">
              <LocationOnIcon sx={{ color: "#22b752", fontSize: 24 }} />
            </span>
          </div>
          <div className="flex flex-col justify-center pl-2 min-h-[28px]">
            <span className="text-sm font-normal leading-tight text-mineshaft-700">
              {updatedAt}
            </span>
            <span className="text-base font-semibold leading-tight text-mineshaft-900">
              {dropoffDisplayName}
            </span>
            <div className="text-sm font-normal leading-tight text-mineshaft-700">
              {dropoffAddress}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeftCard;
